import yup, { Schema, StringSchema, NumberSchema, BooleanSchema, DateSchema, ArraySchema, MixedSchema, ObjectSchema } from "yup";
export { Schema, StringSchema, NumberSchema, BooleanSchema, DateSchema, ArraySchema, MixedSchema, ObjectSchema };
var validators = [];
var Validation = /** @class */ (function () {
    function Validation() {
    }
    Validation.prototype.validate = function (currentScreen) {
        if (currentScreen === void 0) { currentScreen = null; }
        var arr = validators.map(function (validator) {
            return validator.validate(currentScreen);
        });
        return Promise.all(arr);
    };
    Validation.prototype.add = function (schema) {
        validators.push(schema);
    };
    Validation.prototype.remove = function (schema) {
        for (var i = 0; i < validators.length; i++) {
            if (schema === validators[i]) {
                validators.splice(i, 1);
                break;
            }
        }
    };
    Validation.prototype.string = function (msg) {
        var schema = yup.string().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.number = function (msg) {
        var schema = yup.number().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.boolean = function (msg) {
        var schema = yup.boolean().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.bool = function (msg) {
        return this.boolean(msg);
    };
    Validation.prototype.date = function (msg) {
        var schema = yup.date().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.array = function (msg) {
        var schema = yup.array().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.mixed = function (msg) {
        var schema = yup.mixed().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.object = function (msg) {
        var schema = yup.object().nullable(true);
        if (msg) {
            schema = schema.required(msg);
        }
        return schema;
    };
    Validation.prototype.customError = function (str, value, path) {
        if (!str) {
            return true;
        }
        return new yup.ValidationError(str, value, path);
    };
    return Validation;
}());
var validation = new Validation();
export default validation;
export { default as validatedScreen } from "./ScreenHoc";
export { default as ValidationInput } from "./Input";
